import React from "react";
import { auth } from "../firebase-config";
import { useAuthState } from "react-firebase-hooks/auth";
import "./LandingPage.css";
import SharedLayout from "./SharedLayout";

function LandingPage({ onLoginClick }) {
  const [user] = useAuthState(auth);

  return (
    <SharedLayout user={user} onLoginClick={onLoginClick}>
      <div className="landing-container">
        <h1
          style={{
            textAlign: "center",
            marginBottom: "2rem",
            color: "#2c3e50",
            fontSize: "2rem",
          }}
        >
          Personalization. Precision. Performance.
        </h1>
        <div className="content-wrapper">
          <div className="landing-content">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "3rem",
                flexWrap: "wrap",
                gap: "0rem",
              }}
            >
              <div
                className="image-container"
                style={{ width: "calc(33.333% - 0.2rem)", maxWidth: "450px" }}
              >
                <img
                  src={require("../images/F_marathon.png")}
                  alt="Marathon runner"
                  style={{
                    width: "100%",
                    height: "350px",
                    borderRadius: "0px",
                    objectFit: "cover",
                  }}
                />
              </div>
              <div
                className="image-container"
                style={{ width: "calc(33.333% - 0.2rem)", maxWidth: "450px" }}
              >
                <img
                  src={require("../images/F_trophies.png")}
                  alt="Trophies display"
                  style={{
                    width: "100%",
                    height: "350px",
                    borderRadius: "0px",
                    objectFit: "cover",
                  }}
                />
              </div>
              <div
                className="image-container"
                style={{ width: "calc(33.333% - 0.2rem)", maxWidth: "450px" }}
              >
                <img
                  src={require("../images/M_bicycle.png")}
                  alt="Cyclist"
                  style={{
                    width: "100%",
                    height: "350px",
                    borderRadius: "0px",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>

            <div
              style={{
                marginBottom: "2rem",
                lineHeight: "1.8",
                fontSize: "1.1rem",
                color: "#2c3e50",
                textAlign: "justify"
              }}
            >
              <p style={{ marginBottom: "2rem" }}>
                In the high-stakes world of high-performance individuals, mental
                acuity and emotional resilience are critical. As someone who
                operates at the highest levels of performance, your time,
                health, and mental clarity are non-negotiable. Yet, when it
                comes to managing Emotional State, the very foundation of
                high-performance, traditional methods are lacking -
                poorly-informed "one size fits all" assessments jeopardize both
                your time and well-being that in today's advanced technology
                world are simply not good enough for optimized performance.
              </p>
              <p style={{ marginBottom: "2rem" }}>
                Enter <span className="sigmund-text">Sigmund</span>, the
                groundbreaking solution that combines cutting-edge AI
                technology, DNA-based predispositions, exper-guided psychiatrist
                assessment, and personalized biometric insights designed to
                inform your Emotional State and Performance development
                understanding and the level of optimization required to support
                high levels of physical and mental performance.
              </p>
              <p
                style={{
                  textAlign: "center",
                  fontSize: "1.25rem",
                  fontWeight: "500",
                  marginBottom: "2rem",
                }}
              >
                Whether you are an Executive, Athlete or an aspiring
                high-performer, <span className="sigmund-text">Sigmund</span>{" "}
                understands.
              </p>

              <div
                style={{
                  padding: "0.25rem",
                  marginBottom: "2rem",
                }}
              >
                <h3
                  style={{
                    color: "#2c3e50",
                    fontSize: "1.5rem",
                    marginBottom: "1.5rem",
                    textAlign: "center",
                  }}
                >
                  Key Features:
                </h3>
                <ol
                  style={{
                    listStylePosition: "inside",
                    paddingLeft: "1rem",
                    textAlign: "justify"
                  }}
                >
                  <li style={{ marginBottom: "1.5rem" }}>
                    <strong>Comprehensive Data Integration:</strong>{" "}
                    <span className="sigmund-text">Sigmund</span> blends a wide
                    range of data points—from lifestyle choices and
                    environmental factors to genetic predispositions—to deliver
                    holistic, evidence-based Emotional State assessments.{" "}
                    <span className="sigmund-text">Sigmund</span> understands
                    that you are unique, and your mental state needs to be
                    understood in the same way.
                  </li>
                  <li style={{ marginBottom: "1.5rem" }}>
                    <strong>EEG Calibration for Precision:</strong> Real-time
                    EEG data from a population sample established a baseline of
                    "normal" mental states that were correlated with life
                    experience data.{" "}
                    <span className="sigmund-text">Sigmund</span> then compares
                    your data to this baseline, pinpointing emotional
                    divergences with high accuracy. This sophisticated
                    calibration ensures{" "}
                    <span className="sigmund-text">Sigmund</span>'s insights are
                    relevant and precise, without requiring you to undergo EEG
                    testing yourself.
                  </li>
                  <li style={{ marginBottom: "1.5rem" }}>
                    <strong>Genetic Insights:</strong>{" "}
                    <span className="sigmund-text">Sigmund</span>'s custom DNA
                    panel analyzes key genetic markers scientifically-linked to
                    anxiety and depression. Your genetic makeup is as unique as
                    your lifestyle, and{" "}
                    <span className="sigmund-text">Sigmund</span> integrates
                    this information to provide highly-informed Emotional State
                    assessments.
                  </li>
                  <li style={{ marginBottom: "1.5rem" }}>
                    <strong>AI-Driven Predictive Analytics:</strong>{" "}
                    <span className="sigmund-text">Sigmund</span> leverages
                    advanced machine learning algorithms to identify complex
                    patterns in your data. By doing so, it can predict risks,
                    enabling pre-emptive interventions to optimize your
                    emotional state.
                  </li>
                  <li style={{ marginBottom: "1.5rem" }}>
                    <strong>Improved Outcomes:</strong> By identifying
                    predispositions early,{" "}
                    <span className="sigmund-text">Sigmund</span> enables you to
                    take proactive steps toward optimizing your Emotional State,
                    resulting in better long-term outcomes.
                  </li>
                  <li style={{ marginBottom: "1.5rem" }}>
                    <strong>Clinically studied:</strong> Backed by a clinical
                    study at York University,{" "}
                    <span className="sigmund-text">Sigmund</span>'s methodology
                    and algorithms have been rigorously tested to ensure
                    exceptional accuracy across various metrics. This means{" "}
                    <span className="sigmund-text">Sigmund</span> isn't just
                    innovative—it's proven.
                  </li>
                </ol>
                <p
                  style={{
                    marginTop: "2rem",
                    textAlign: "center",
                    fontStyle: "italic",
                    fontSize: "1.1rem",
                  }}
                >
                  Whether you're an executive, athlete, or young "up and comer",{" "}
                  <span className="sigmund-text">Sigmund</span> gives you the
                  edge you need to maintain mental clarity, emotional
                  resilience, and peak performance. It's not about waiting for
                  problems to emerge – it's about taking control, understanding
                  your Emotional State and how it affects your mental and
                  physical performance, and staying ahead of the curve.{" "}
                  <span className="sigmund-text">Sigmund</span> is not just a
                  mental health tool —{" "}
                  <span className="sigmund-text">
                    it's a life optimization system.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SharedLayout>
  );
}

export default LandingPage;
